<p-multiSelect 
    [options]="data()"
    autoWidth="false"
    optionLabel="value"
    optionValue="id"
    name="selectedOption"
    [(ngModel)]="selectedOption" 
    [placeholder]="placeholder()"
    [style]="{ width: width() + '%', height: height() + 'px' }"
    [showToggleAll]="selectAll()"
    [disabled]="disabled()"
    (onChange)="onTeamsSelectionChange($event)"
    selectedItemsLabel="{0} items selected"
    [resetFilterOnHide]="true"
    appendTo="body"
    >
</p-multiSelect>